export const DEFAULT_FILTER_DEBOUNCE_TIME_MS = 300;
export const DEFAULT_TEMPLATE_KEY = 'DEFAULT_TEMPLATE';
export const SECTIONS_LAYOUT_KEY = 'SECTIONS_LAYOUT';
export const ITINERARY_MAX_ACTIVITY_SELECTION_LIMIT = 50;
export const ITINERARY_MAX_EXTERNAL_PARTICIPANT_LIMIT = 200;
